import React, { useState, useCallback } from 'react';
import Header from './Header';
import Main from './Main';
import Modal from '../composants/Modal.js';

function Container({ user, setUser, creatingSession, setCreatingSession, joinSession, setJoinSession }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(<></>);
  const [modalTitle, setModalTitle] = useState("");
  // État partagé pour currentPhase entre Header et Main/Session
  const [currentPhase, setCurrentPhase] = useState(0);
  // États pour les fonctions admin
  const [goNext, setGoNext] = useState(() => () => {});
  const [closeSession, setCloseSession] = useState(() => () => {});
  // État pour gérer si on est dans les résultats finaux
  const [endSession, setEndSession] = useState(false);

  const handleEndSessionChange = useCallback((newEndSession) => {
    setEndSession(newEndSession);
  }, []);

  return (
    <>
      <Header
        user={user}
        setUser={setUser}
        creatingSession={creatingSession}
        setCreatingSession={setCreatingSession}
        joinSession={joinSession}
        setJoinSession={setJoinSession}
        isAdmin={isAdmin}
        setIsAdmin={setIsAdmin}
        currentPhase={currentPhase}
        goNext={goNext}
        closeSession={closeSession}
        isEndSession={endSession} // MODIFIÉ : Prop pour indiquer l'état de fin de session
      />
      <div className="main-content">
        <Main
          user={user}
          setUser={setUser}
          creatingSession={creatingSession}
          setCreatingSession={setCreatingSession}
          joinSession={joinSession}
          setJoinSession={setJoinSession}
          isAdmin={isAdmin}
          setIsAdmin={setIsAdmin}
          setModalContent={setModalContent}
          setModalTitle={setModalTitle}
          setShowModal={setShowModal}
          currentPhase={currentPhase}
          setCurrentPhase={setCurrentPhase}
          setGoNext={setGoNext}
          setCloseSession={setCloseSession}
          onEndSessionChange={handleEndSessionChange}  // Callback pour recevoir endSession
        />
      </div>
      {showModal && (
        <Modal title={modalTitle} onClose={() => setShowModal(false)}>
          {modalContent}
        </Modal>
      )}
    </>
  );
}

export default Container;